
import React from "react";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ThankYouMessageProps {
  title?: string;
  message?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  selectedPlan?: string;
}

const ThankYouMessage: React.FC<ThankYouMessageProps> = ({
  title = "Obrigado pelo seu interesse!",
  message = "Em breve entraremos em contato.",
  buttonText = "Voltar para a página inicial",
  onButtonClick,
  selectedPlan
}) => {
  return (
    <div className="py-12 px-4 max-w-md mx-auto text-center">
      <div className="bg-green-50 rounded-full p-3 w-16 h-16 mx-auto mb-6 flex items-center justify-center">
        <CheckCircle className="w-10 h-10 text-green-600" />
      </div>
      
      <h2 className="text-2xl font-bold text-gray-800 mb-4">{title}</h2>
      
      {selectedPlan && (
        <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 mb-4">
          <p className="font-medium text-blue-800">
            Você escolheu o plano {selectedPlan} — 7 dias grátis!
          </p>
        </div>
      )}
      
      <p className="text-gray-600 mb-6">{message}</p>
      
      {onButtonClick && (
        <Button 
          onClick={onButtonClick}
          className="bg-toctoc-blue hover:bg-toctoc-blue/90 text-white rounded-full"
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
};

export default ThankYouMessage;
